import React from "react";
import ShoppingListItem from "./ShoppingListItem";
import {setItemcategory} from "../service.js";

export default function CategoryList({
    categoryIngredientList,
    categoryName,
    handleTick,
    updateMealsFromServer,
    handleEdit,
    handleDelete,
    index,
    plan
  }){
  let categoryClass = "m"
  if (categoryName === "Tat"){
    categoryClass = "t"
  }
  if (categoryName === "Drinks"){
    categoryClass = "b"
  }

  function handleCategoryDown(i){
      updateMealsFromServer((prevMealList) => {
        const meals_with_ingredient = categoryIngredientList[i].fromMeal.map((mealWithIngredient) => mealWithIngredient.id)
        const newMealList = prevMealList.map((meal)=> {
          if(meals_with_ingredient.includes(meal.id)){
            return {...meal, ingredients: meal.ingredients.map((ingredient) => ingredient.id === categoryIngredientList[i].id ? {...ingredient,category:categoryIngredientList[i].category+1}:ingredient)}
          }
          else{
            return meal
          }
          }
        )
        return newMealList
      })
      console.log(categoryIngredientList[i].fromMeal)
      setItemcategory(categoryIngredientList[i].fromMeal[0].id,categoryIngredientList[i].id,categoryIngredientList[i].category+1)
    }
  
    function handleCategoryUp(i){
      updateMealsFromServer((prevMealList) => {
        const meals_with_ingredient = categoryIngredientList[i].fromMeal.map((mealWithIngredient) => mealWithIngredient.id)
        const newMealList = prevMealList.map((meal)=> {
          if(meals_with_ingredient.includes(meal.id)){
            return {...meal, ingredients: meal.ingredients.map((ingredient) => ingredient.id === categoryIngredientList[i].id ? {...ingredient,category:categoryIngredientList[i].category-1}:ingredient)}
          }
          else{
            return meal
          }
          }
        )
        return newMealList
      })
      console.log(categoryIngredientList[i].fromMeal)
      setItemcategory(categoryIngredientList[i].fromMeal[0].id,categoryIngredientList[i].id,categoryIngredientList[i].category-1)
    }

  return (
    <div className="category">
      <h4 className="category--name">
      {`${index+1} - ${categoryName}`} 
      </h4>
      <div className="category--list">
        {
          categoryIngredientList.map(
            (li,i) => (!li.ticked) ?
            <ShoppingListItem key={i}
            categoryIndex={i} //needs fixing
            originalIndex={li.oi}
            checked={false}
            stocked={li.stocked}
            label={li.label}
            fromMeal={li.fromMeal}
            handleTick={handleTick}
            handleEdit={handleEdit}
            handleCategoryDown={handleCategoryDown}
            handleCategoryUp={handleCategoryUp}
            handleDelete={handleDelete}
            categoryClass={categoryClass}
            justMade={i===0 && li.label === "new"}
            plan={plan}
            /> : null
          )
        }
      </div>
    </div>
  )
}